/**
 * Kept in its own file so `Root` can read it without pulling the board chunk
 * into the main bundle (the investor's `surface.ts` shape, BOARD.md §2.7).
 *
 * The key is the data room's — one `localStorage` slot says which outside
 * surface this browser last held, `'investor'` or `'board'`. Written by
 * `BoardApp` and the sign-in page, read by `Root` to show a signed-out member
 * the re-link page rather than Microsoft sign-in. A convenience only: it grants
 * nothing, and an empty value means the staff sign-in.
 */
import { INVESTOR_SURFACE_KEY } from '@/modules/data-room/investor/surface'

export const BOARD_SURFACE_KEY = INVESTOR_SURFACE_KEY
export const BOARD_SURFACE_VALUE = 'board'

/**
 * `board_api.me.last_seen_at` as it was BEFORE this visit recorded anything —
 * the sign-in page reads it before it records the `sign_in`, so "new since
 * your last visit" is not "new since a second ago". Session storage: one tab,
 * one visit.
 */
export const BOARD_PREVIOUS_VISIT_KEY = 'excellence:board:previous-visit'

export function rememberBoardSurface() {
  try {
    localStorage.setItem(BOARD_SURFACE_KEY, BOARD_SURFACE_VALUE)
  } catch {
    /* private mode: the signed-out page is a convenience */
  }
}

export function rememberedBoard(): boolean {
  try {
    return localStorage.getItem(BOARD_SURFACE_KEY) === BOARD_SURFACE_VALUE
  } catch {
    return false
  }
}

/** For "Digitopia staff? Sign in with Microsoft": otherwise `/` lands back here. */
export function forgetBoardSurface() {
  try {
    if (localStorage.getItem(BOARD_SURFACE_KEY) === BOARD_SURFACE_VALUE) localStorage.removeItem(BOARD_SURFACE_KEY)
  } catch {
    /* nothing to forget */
  }
}
